const fuelOptions = [
  {
    value: "Wind",
    label: "Wind",
  },
  {
    value: "Solar",
    label: "Solar",
  },
  {
    value: "Wind and solar",
    label: "Wind and solar",
  },
  {
    value: "Hydro",
    label: "Hydro",
  },
  {
    value: "Bioenergy",
    label: "Bioenergy",
  },
  {
    value: "Other Renewables",
    label: "Other Renewables",
  },
  {
    value: "Renewables",
    label: "Renewables",
  },
  {
    value: "Clean",
    label: "Clean",
  },
  {
    value: "Nuclear",
    label: "Nuclear",
  },
  {
    value: "Coal",
    label: "Coal",
  },
  {
    value: "Gas",
    label: "Gas",
  },
  {
    value: "Other Fossil",
    label: "Other Fossil",
  },
  {
    value: "Fossil",
    label: "Fossil",
  },
];

const fuelSeries = [
  {
    name: "Wind",
    color: "#146639",
  },
  {
    name: "Solar",
    color: "#199A59",
  },
  {
    name: "Bioenergy",
    color: "#45B872",
  },
  {
    name: "Other Renewables",
    color: "#96D0B2",
  },
  {
    name: "Hydro",
    color: "#AFDAF5",
  },
  {
    name: "Nuclear",
    color: "#1D6DA9",
  },
  {
    name: "Other Fossil",
    color: "#AAABAB",
  },
  {
    name: "Gas",
    color: "#676767",
  },
  {
    name: "Coal",
    color: "#343433",
  },
];

export { fuelOptions, fuelSeries };
